import { c as _c } from "react/compiler-runtime";
import { PixelArrow } from "@/components/ui/pixel-arrow";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
const EDGE_PADDING_PX = 32;
const SKELETON_CARD_COUNT = 6;
const arrowButtonClassName = cn("border-ds-border-default bg-ds-surface-card text-ds-text-secondary group -mr-px flex size-9 items-center justify-center overflow-hidden border p-[3px]");
export function FeaturedTemplatesCarouselSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-ds-text-primary leading-30 text-xl font-medium">Featured on B3OS</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      dir: "prev",
      arrow: "left"
    }, {
      dir: "next",
      arrow: "right"
    }];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-4 flex items-center justify-between gap-4 px-8">{t0}<div className="flex items-start pr-px" aria-hidden={true}>{(t1 as const).map(_temp)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingInline: `${EDGE_PADDING_PX}px`,
      scrollPaddingInline: `${EDGE_PADDING_PX}px`
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="pb-10 pt-4" aria-label="Loading featured templates">{t2}<div className="scrollbar-hide flex snap-x snap-mandatory gap-5 overflow-hidden pb-2 pt-1" style={t3} aria-hidden={true}>{Array.from({
          length: SKELETON_CARD_COUNT
        }).map(_temp2)}</div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp2(_, i) {
  return <div key={i} className="snap-start"><FeaturedTemplateCardSkeleton /></div>;
}
function _temp(btn) {
  return <div key={btn.dir} className={arrowButtonClassName}><PixelArrow direction={btn.arrow} /></div>;
}
function FeaturedTemplateCardSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-ds-surface-sunken border-ds-border rounded-ds-xs h-[105px] overflow-hidden border" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton className="rounded-ds-2xs h-[22px] w-[220px]" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="border-ds-border-default bg-ds-surface-card rounded-ds-md shadow-ds-soft block w-[300px] shrink-0 border"><div className="flex flex-col gap-5 px-2 pb-5 pt-2">{t0}<div className="flex flex-col items-start gap-1 px-3.5">{t1}<div className="w-full space-y-1"><Skeleton className="rounded-ds-2xs h-4 w-full" /><Skeleton className="rounded-ds-2xs h-4 w-[78%]" /></div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}